"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var React = __importStar(require("react"));
var LayoutContext_1 = require("../Common/LayoutContext");
var useTracking_1 = __importDefault(require("../Common/utils/useTracking"));
var CardFields_1 = __importDefault(require("./CardFields"));
var StripeContainer_1 = __importDefault(require("./StripeContainer"));
var VerifyCardError_1 = __importDefault(require("./VerifyCardError"));
var VerifyPaymentCardContext_1 = __importDefault(require("./VerifyPaymentCardContext"));
var VerifyPaymentCardMutation_1 = __importDefault(require("./VerifyPaymentCardMutation"));
var VerifyPaymentCardStrings_1 = __importDefault(require("./VerifyPaymentCardStrings"));
var VerifyPaymentCard = function (_a) {
    var onClose = _a.onClose;
    var _b = React.useContext(LayoutContext_1.LayoutContext), primaryAction = _b.primaryAction, setPrimaryAction = _b.setPrimaryAction;
    var _c = React.useContext(VerifyPaymentCardContext_1["default"]), paymentCard = _c.paymentCard, stripeKey = _c.stripeKey;
    var _d = useTracking_1["default"](), trackClick = _d.trackClick, trackFailure = _d.trackFailure, trackSuccess = _d.trackSuccess;
    // tslint:disable-next-line:max-line-length
    var defaultError = VerifyPaymentCardStrings_1["default"].unableToVerifyPleaseTryAgain();
    return (React.createElement(StripeContainer_1["default"], { stripeKey: stripeKey },
        React.createElement(VerifyPaymentCardMutation_1["default"], null, function (verifyPaymentCard, res) { return (React.createElement(CardFields_1["default"], { customError: React.createElement(VerifyCardError_1["default"], { defaultError: defaultError, submitRes: res }), isInline: false, onSubmit: function (token) {
                return verifyPaymentCard(paymentCard.id, token);
            }, submitRes: res, onClose: onClose, submitting: primaryAction.isSubmitting, onFinish: function () { return setPrimaryAction({ isSubmitting: false }); }, supportBillingAddress: true, trackClick: trackClick, trackFailure: trackFailure, trackSuccess: trackSuccess })); })));
};
exports["default"] = VerifyPaymentCard;
